<div class="mt-2 d-none d-md-block">
  <div class="d-flex justify-content-between">
    <div class="d-flex align-items-center mb-2">
      <h2 class="mb-0 me-3">{{"software.latestVersion" | translate}}@if (artifact.version) {
        <span>: {{artifact.version}}</span>
        }@if (artifact.size) {
        <span
        > ({{artifact.size | fileSize}})</span>
      }</h2>
      @if (software.platform) {
        <span class="badge platform-label me-2">{{software.platform.name}}</span>
      }
      @if (software.type) {
        <span class="badge type-label me-2">{{software.type.name}}</span>
      }
      @if (artifact.releaseType) {
        <span class="badge release-type-label me-2">{{artifact.releaseType!.name}}</span>
      }
      @if (artifact.status === SoftwareArtifactStatus.WITHDRAWN) {
        <span class="badge withdrawn-label me-2">{{ 'software.artifact.statusItems.withdrawn' | translate }}</span>
      }
    </div>
    @if (artifact.status !== SoftwareArtifactStatus.WITHDRAWN) {
      <app-software-artifact-download-button class="me-2" [artifact]="artifact"></app-software-artifact-download-button>
    }
  </div>
  @if (software.description) {
    <markdown [data]="software.description"></markdown>
  }
  <div class="d-flex flex-column text-addition">
    @if (artifact.buildNumber) {
      <span><b>{{ 'software.artifact.buildNumber' | translate }}</b>: {{artifact.buildNumber}}</span>
    }
    @if (isAdmin && artifact.branchName) {
      <span><b>{{ 'software.artifact.branchName' | translate }}</b>: {{artifact.branchName}}</span>
    }
    @if (artifact.releaseDate) {
      <span><b>{{ 'software.artifact.releaseDate' | translate }}</b>: {{artifact.releaseDate | dateTime}}</span>
    }
  </div>
  <hr>
    @if (artifact.changelog) {
      <div class="latest-changes">
        <h3>{{"software.latestChanges" | translate}}</h3>
        <markdown [data]="artifact.changelog"></markdown>
      </div>
      <hr>
      }
    </div>
    <div class="m-2 mt-3 d-block d-md-none">
      <h2 class="me-3">{{"software.latestVersion" | translate}}@if (artifact.version) {
        <span>: {{artifact.version}}</span>
        }@if (artifact.size) {
        <span
        > ({{artifact.size | fileSize}})</span>
      }</h2>
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          @if (software.platform) {
            <span class="badge platform-label me-2">{{software.platform.name}}</span>
          }
          @if (software.type) {
            <span class="badge type-label me-2">{{software.type.name}}</span>
          }
          @if (artifact.releaseType) {
            <span class="badge release-type-label me-2">{{artifact.releaseType!.name}}</span>
          }
          @if (artifact.status === SoftwareArtifactStatus.WITHDRAWN) {
            <span class="badge withdrawn-label me-2">{{ 'software.artifact.statusItems.withdrawn' | translate }}</span>
          }
        </div>
        @if (artifact.status !== SoftwareArtifactStatus.WITHDRAWN) {
          <app-software-artifact-download-button class="me-2" [artifact]="artifact"></app-software-artifact-download-button>
        }
      </div>
      @if (software.description) {
        <markdown [data]="software.description"></markdown>
      }
      <div class="d-flex flex-column text-addition">
        @if (artifact.buildNumber) {
          <span><b>{{ 'software.artifact.buildNumber' | translate }}</b>: {{artifact.buildNumber}}</span>
        }
        @if (isAdmin && artifact.branchName) {
          <span><b>{{ 'software.artifact.branchName' | translate }}</b>: {{artifact.branchName}}</span>
        }
        @if (artifact.releaseDate) {
          <span><b>{{ 'software.artifact.releaseDate' | translate }}</b>: {{artifact.releaseDate | dateTime}}</span>
        }
      </div>
      <hr>
        @if (artifact.changelog) {
          <div class="latest-changes">
            <h3>{{"software.latestChanges" | translate}}</h3>
            <markdown [data]="artifact.changelog"></markdown>
          </div>
          <hr>
          }
        </div>
